import { Model } from '@vuex-orm/core'
import { UploadDto } from './upload.interface'
import { Constants } from '@/constants'

export default class Upload extends Model {
    static entity = 'uploads'

    static fields() {
        return {
            id: this.attr(null),
            email: this.attr(''),
            name: this.attr('')
        }
    }

    static async upload(file: File) {
        const form = new FormData()
        form.append('file', file)
        return await this.api().post(Constants.API.UPLOAD, form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }

    static apiConfig = {
        actions: {
            fetch: {
                method: 'get',
                url: '/uploads'
            }
        }
    }
}
